import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appDateMask]',
})
export class DateMaskDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(event: any) {
    let input = this.el.nativeElement.value;
    input = input.replace(/\D/g, '');
    input = input.substring(0, 8);

    const day = input.substring(0, 2);
    const month = input.substring(2, 4);
    const year = input.substring(4, 8);

    if (input.length > 4) {
      this.el.nativeElement.value = `${day}/${month}/${year}`;
    } else if (input.length > 2) {
      this.el.nativeElement.value = `${day}/${month}`;
    } else {
      this.el.nativeElement.value = day;
    }
  }

  @HostListener('blur', ['$event'])
  onBlur(event: any) {
    let input = this.el.nativeElement.value;

    if (input.length !== 10) {
      this.el.nativeElement.value = '';
    }
  }
}
